import _globalThis2 from "../internals/global-this";
import _functionUncurryThisAccessor from "../internals/function-uncurry-this-accessor";
import _classofRaw from "../internals/classof-raw";
var exports = {};
var _globalThis = _globalThis2;
var uncurryThisAccessor = _functionUncurryThisAccessor;
var classof = _classofRaw;
var ArrayBuffer = _globalThis.ArrayBuffer;
var TypeError = _globalThis.TypeError;

// Includes
// - Perform ? RequireInternalSlot(O, [[ArrayBufferData]]).
// - If IsSharedArrayBuffer(O) is true, throw a TypeError exception.
exports = ArrayBuffer && uncurryThisAccessor(ArrayBuffer.prototype, "byteLength", "get") || function (O) {
  if (classof(O) !== "ArrayBuffer") throw new TypeError("ArrayBuffer expected");
  return O.byteLength;
};
export default exports;